import { render } from "./ExternalSearchRequests.vue?vue&type=template&id=47d38c92&ts=true"
import script from "./ExternalSearchRequests.vue?vue&type=script&lang=ts"
export * from "./ExternalSearchRequests.vue?vue&type=script&lang=ts"

import "./ExternalSearchRequests.vue?vue&type=style&index=0&id=47d38c92&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__